
import DemandList from '../components/demand-list.vue';

export default {
  name: 'SubmittedDemandList',

  components: {
    DemandList: DemandList
  }
};